import styled from "styled-components";

import {
  fontSizes,
  lineHeights,
  emptyStateTitle,
} from "../../shared/styles/typography";
import { tokens } from "../../theme/tokens";

const BP = tokens.layout.mobileFirstExpandPx;

export const PRIMARY = "#5F33E1";
export const PRIMARY_BORDER = "#4A2BB8";
export const PINK = "#EC4899";
export const GREEN = "#10B981";
export const DANGER = "#EF4444";

export const PageWrap = styled.div`
  padding: 0 16px 120px;
  width: 100%;
  max-width: var(--layout-app-shell-max);
  margin: 0 auto;
  box-sizing: border-box;

  @media (min-width: ${BP}px) {
    padding-left: 0;
    padding-right: 0;
  }
`;

export const FavoritesHint = styled.button`
  display: block;
  width: 100%;
  margin-bottom: 12px;
  padding: 10px 14px;
  border-radius: 12px;
  border: 1px solid var(--color-border);
  background: var(--color-surface);
  font-size: ${fontSizes.sm}px;
  line-height: ${lineHeights.sm}px;
  color: var(--color-primary);
  font-weight: var(--font-weight-semibold);
  text-align: center;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(95, 51, 225, 0.06);

  &:active {
    opacity: 0.92;
  }
`;

export const HeroCard = styled.div`
  border-radius: 12px;
  background: ${PRIMARY};
  border: 2px solid ${PRIMARY_BORDER};
  padding: 12px;
  margin-bottom: 12px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
`;

export const HeroTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
`;

export const HeroBadge = styled.span`
  background: rgba(255, 255, 255, 0.25);
  padding: 4px 8px;
  border-radius: 6px;
  border: 1.5px solid rgba(255, 255, 255, 0.4);
  color: #fff;
  font-size: ${fontSizes.xs}px;
  line-height: ${lineHeights.xs}px;
  font-weight: var(--font-weight-bold);
  text-transform: uppercase;
  letter-spacing: 0.12em;
`;

export const HeroFolder = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.2);
  border: 1.5px solid rgba(255, 255, 255, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const HeroTitle = styled.p`
  margin: 0 0 4px;
  color: #fff;
  font-size: ${fontSizes.base}px;
  line-height: ${lineHeights.base}px;
  font-weight: var(--font-weight-bold);
  letter-spacing: 0.02em;
`;

export const HeroSub = styled.p`
  margin: 0 0 10px;
  color: #fff;
  font-size: ${fontSizes.sm}px;
  line-height: ${lineHeights.sm}px;
  opacity: 0.95;
`;

export const ProgressTrack = styled.div`
  height: 8px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 8px;
`;

export const ProgressFill = styled.div<{ $pct: number }>`
  height: 100%;
  width: ${(p) => p.$pct}%;
  background: #fff;
  border-radius: 4px;
  transition: width 0.25s ease;
`;

export const HeroFoot = styled.div`
  display: flex;
  justify-content: space-between;
  color: #fff;
  font-size: ${fontSizes.sm}px;
  line-height: ${lineHeights.sm}px;
  font-weight: var(--font-weight-semibold);
  opacity: 0.9;
`;

export const SearchCard = styled.div`
  background: var(--color-surface);
  border-radius: 16px;
  padding: 12px 14px;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  gap: 10px;
  border: 1px solid var(--color-border);
`;

export const SearchInput = styled.input`
  flex: 1;
  border: none;
  background: transparent;
  font-size: ${fontSizes.base}px;
  line-height: ${lineHeights.base}px;
  outline: none;
  color: var(--color-text-title);

  &::placeholder {
    color: var(--color-text-secondary);
  }
`;

export const VideoCard = styled.article`
  background: var(--color-surface);
  border-radius: 16px;
  padding: 16px;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid var(--color-border);
`;

export const VideoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const VideoIconBox = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: ${PINK};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const VideoText = styled.div`
  flex: 1;
  min-width: 0;
`;

export const VideoTitle = styled.h3`
  margin: 0;
  font-size: ${fontSizes.base}px;
  line-height: ${lineHeights.base}px;
  font-weight: var(--font-weight-bold);
  color: var(--color-text-title);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const VideoDesc = styled.p`
  margin: 4px 0 0;
  font-size: ${fontSizes.sm}px;
  line-height: ${lineHeights.sm}px;
  color: var(--color-text-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const PlayBtn = styled.button`
  padding: 8px;
  border-radius: 12px;
  border: 1px solid rgba(95, 51, 225, 0.25);
  background: rgba(95, 51, 225, 0.15);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  &:active {
    transform: scale(0.96);
  }
`;

export const Divider = styled.div`
  height: 1px;
  background: #e2e8f0;
  margin: 16px 0;
  opacity: 0.35;
`;

export const ShareRow = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px;
  border-radius: 12px;
  border: none;
  background: rgba(16, 185, 129, 0.1);
  cursor: pointer;
  margin-bottom: 8px;

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }

  &:active:not(:disabled) {
    transform: scale(0.99);
  }
`;

export const ShareIconWrap = styled.span`
  width: 32px;
  height: 32px;
  border-radius: 16px;
  background: ${GREEN};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ShareLabel = styled.span`
  font-size: ${fontSizes.sm}px;
  line-height: ${lineHeights.sm}px;
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-title);
`;

export const ActionsRow = styled.div`
  display: flex;
  gap: 8px;
  width: 100%;
`;

export const HalfAction = styled.button`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 8px;
  border-radius: 12px;
  border: none;
  cursor: pointer;
  font-size: ${fontSizes.sm}px;
  line-height: ${lineHeights.sm}px;
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-title);

  &:active {
    transform: scale(0.99);
  }
`;

export const EditAction = styled(HalfAction)`
  background: rgba(95, 51, 225, 0.1);
`;

export const DeleteAction = styled(HalfAction)`
  background: rgba(239, 68, 68, 0.1);
`;

export const ActionIconSm = styled.span<{ $bg: string }>`
  width: 32px;
  height: 32px;
  border-radius: 16px;
  background: ${(p) => p.$bg};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const EmptyWrap = styled.div`
  text-align: center;
  padding: 48px 24px 32px;
`;

export const EmptyCircle = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 40px;
  background: rgba(95, 51, 225, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
`;

export const EmptyTitle = styled.h2`
  ${emptyStateTitle}
  margin: 0 0 8px;
`;

export const EmptyText = styled.p`
  font-size: ${fontSizes.sm}px;
  line-height: ${lineHeights.sm}px;
  color: var(--color-text-secondary);
  margin: 0;
`;

export const FabWrap = styled.div`
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  bottom: calc(var(--tab-bar-clearance, 84px) + 12px);
  width: calc(100% - 32px);
  max-width: min(468px, var(--layout-app-shell-max));
  padding: 0 16px;
  z-index: 20;
  pointer-events: none;
  box-sizing: border-box;

  @media (min-width: ${BP}px) {
    max-width: var(--layout-app-shell-max);
    width: 100%;
    padding: 0 max(1.2rem, env(safe-area-inset-left)) 0
      max(1.2rem, env(safe-area-inset-right));
  }

  & > * {
    pointer-events: auto;
  }
`;

export const FabBtn = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 16px;
  border-radius: 16px;
  border: none;
  background: ${PRIMARY};
  color: #fff;
  font-size: ${fontSizes.base}px;
  line-height: ${lineHeights.base}px;
  font-weight: var(--font-weight-bold);
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(95, 51, 225, 0.35);

  &:disabled {
    opacity: 0.75;
    cursor: not-allowed;
  }

  &:active:not(:disabled) {
    transform: scale(0.99);
  }
`;

export const LoadingCenter = styled.div`
  text-align: center;
  padding: 48px 16px;
  color: var(--color-text-secondary);
  font-size: ${fontSizes.sm}px;
  line-height: ${lineHeights.sm}px;
  font-weight: var(--font-weight-semibold);
`;
